import _ from 'lodash';

const mutations = {
  SET_CURRENT_USER: (state, payload) => {
    state.user = payload.user;
  },
  SET_CURRENT_CITY: (state, payload) => {
    state.currentCity = payload.city;
  },
  SET_CENTER_MAP: (state, payload) => {
    state.currentMapCenter = { lat: payload.lat, lng: payload.lng };
  },
  SET_CURRENT_MERCHANT: (state, payload) => {
    state.currentMerchant = payload.merchant;
  },
  SET_CURRENT_PLACE_ID: (state, payload) => {
    state.currentPlaceID = payload;
  },
};

export default mutations;



// WEBPACK FOOTER //
// ./src/store/modules/app/mutations.js